import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { CreateUserDocument, UserDocument } from 'Pages/profile'
import { serialize } from 'object-to-formdata'
import { SimpleResponse } from 'Types/simpleResponse'

async function getAll() {
	const res = await axiosDS().get<UserDocument[]>(urls.user_documents.index)
	return res.data
}

async function createOne(user_document: CreateUserDocument) {
	const res = await axiosDS().post<CreateUserDocument>(
		urls.user_documents.index,
		serialize({ user_document }, { allowEmptyArrays: true })
	)
	return res.data
}

async function deleteOne(id: number) {
	const res = await axiosDS().delete<SimpleResponse>(`${urls.user_documents.index}/${id}`)
	return res.data
}

export const userDocumentsApi = {
	getAll,
	createOne,
	deleteOne,
}
